import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';

export const CmsPage = ({ fetchCms, isLoading, cms }) => {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    if(slug){
        fetchCms(slug);
    }
  }, [slug]);

  return (
    <>
        <div className="full-row bg-light overlay-dark py-5"
            style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
            <div className="container">
            <div className="row text-center text-white">
                <div className="col-12">
                <h3 className="mb-2 text-white font-weight-bold">{cms?.title}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center bg-transparent">
                    <li className="breadcrumb-item">
                        <a href="#" className="text-white">Home</a>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">{cms?.title}</li>
                    </ol>
                </nav>
                </div>
            </div>
            </div>
        </div>
        <section className="products" style={{ maxWidth: "1350px", margin: "auto", paddingTop: "30px" }}>
            <div className="container">
                <div className="row">
                    <div dangerouslySetInnerHTML={{ __html: cms?.details }} />
                </div>
            </div>
        </section>
    </>
  );
};
